import { WinningType } from "./enum/winningType";
import { WinnerAnswerStatus } from "./enum/winnerAnswerStatus";
import { WinnerCustomInfo } from "./WinnerCustomInfo";
import { EventRewardDto } from "./eventReward";

export interface WinnerDto {
  sequenceNumber: number;
  winningType: string;
  winningAnswerStatus: string;
  personalMessage: { [key: string]: string } | null;
  memo: string | null;
}

export class Winner {
  sequenceNumber: number;
  winningType: WinningType;
  winnerAnswerStatus: WinnerAnswerStatus;
  customMessageInfo: WinnerCustomInfo | null;
  memo: string | null;

  constructor(dto: WinnerDto, reward: EventRewardDto) {
    this.sequenceNumber = dto.sequenceNumber;
    this.winningType = WinningType[dto.winningType as keyof typeof WinningType];
    this.winnerAnswerStatus =
      WinnerAnswerStatus[
        dto.winningAnswerStatus as keyof typeof WinnerAnswerStatus
      ];
    this.customMessageInfo = reward.eventWinningMessage
      ? new WinnerCustomInfo(reward.eventWinningMessage, dto.personalMessage)
      : null;
    this.memo = dto.memo;
  }
}
